import * as Stripe from "@stripe/stripe-js"
import { MtPackage, MtCart, MtBillingHistory } from "server/models"


export interface StripePaymentIntent {
    id: string
    clientSecret: string
    amount: number
    status: Stripe.PaymentIntent.Status
}
export interface StripePaymentIntentData {
    paymentIntentId: string
    accountId: number
    userId: number
    userName: string
    userEmail: string
}


export interface Billing {
    stripePromise: any

    availablePackages: readonly MtPackage[]

    billingHistory: readonly MtBillingHistory[]
    reloadBillingHistory: boolean

    cart: readonly MtCart[]
    reloadCart: boolean
}

export const BILLING_STRIPE_PROMISE = "BILLING_STRIPE_PROMISE"

export const BILLING_AVAILABLE_PACKAGES = "BILLING_AVAILABLE_PACKAGES"

export const BILLING_HISTORY = "BILLING_HISTORY"
export const BILLING_RELOAD_HISTORY = "BILLING_RELOAD_HISTORY"

export const BILLING_CART = "BILLING_CART"
export const BILLING_RELOAD_CART = "BILLING_RELOAD_CART"
